import { render, staticRenderFns } from "./Contract-Terms-Conditions.vue?vue&type=template&id=64c75c24"
import script from "./Contract-Terms-Conditions.vue?vue&type=script&lang=js"
export * from "./Contract-Terms-Conditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports